import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table } from 'reactstrap';

import moment from "moment";

import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

import { getReadableTipoPedido, getUrlMisPedidosTipoPedido } from "./enums.js";


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,

            codigoVerificacion: null,
            orden: "",
            fecha: null,
            planta: "",
            lugarDeEntrega: "",
            centroDeCosto: "",
            persona: "",
            estado: null,
            observacion: "",

            detalle: [],

            errors: [],
        };
    }

    static propTypes = {
        id: PropTypes.func,
        missingIdMessage: PropTypes.string,
        initOpen: PropTypes.func,
        action: PropTypes.oneOf(['DETAIL']).isRequired,
        tipo_pedido: PropTypes.string.isRequired, // Ver enums.js en esta carpeta para saber cuales son los posibles valores
    }

    resetForm() {
        this.setState({
            id: null,

            codigoVerificacion: null,
            orden: "",
            fecha: null,
            planta: "",
            lugarDeEntrega: "",
            centroDeCosto: "",
            persona: "",
            estado: null,
            observacion: "",

            detalle: [],

            errors: [],
        });
    }

    setData(data) {
        // Request data de la api para cargar los detalles del pedido de producto
        if (data.success) {
            const id = data.id ? data.id : null;
            const codigoVerificacion = data.codigo_verificacion ? data.codigo_verificacion : null;
            const orden = data.orden ? data.orden : "";
            const fecha = data.fechaCreacion ? data.fechaCreacion : null;
            // "Planta" es como el alta llama al comedor elegido, ver el label
            // del select de comedor_id en FormPedidosProducto.js.
            const planta = data.comedor_nombre ? data.comedor_nombre : "";
            // Ya viene resuelto: es el nombre del area elegida, o el texto que
            // se escribio a mano cuando el lugar de entrega fue "Otros".
            const lugarDeEntrega = data.lugar_de_entrega ? data.lugar_de_entrega : "";
            const centroDeCosto = data.dependencia_nombre ? data.dependencia_nombre : "";
            const persona = data.persona_nombre ? data.persona_nombre : "";
            const estado = data.estado_nombre ? data.estado_nombre : null;
            const observacion = data.observacion ? data.observacion : "";
            const detalle = data.pedidosdetalle_set ? data.pedidosdetalle_set : [];

            this.setState({
                id,
                codigoVerificacion,
                orden,
                fecha,
                planta,
                lugarDeEntrega,
                centroDeCosto,
                persona,
                estado,
                observacion,

                detalle,
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action, id, tipo_pedido } = this.props;
        if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                submitUrl: null,
                title: "Detalle del Pedido de " + getReadableTipoPedido(tipo_pedido),
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                saveButtonLabel: null,
                buttonClass: "",
                disabled: true,
                id: id,
            };
        }
    }



    render() {
        const {
            codigoVerificacion,
            orden,
            fecha,
            planta,
            lugarDeEntrega,
            centroDeCosto,
            persona,
            estado,
            observacion,

            detalle,
        } = this.state;

        const {
            missingIdMessage,
            tipo_pedido,
        } = this.props;

        const vars = this.modalVars()
        const missingPedidoIdMessage = missingIdMessage ? missingIdMessage : "Debe seleccionar una fila.";

        const fechaFormateada = fecha ? moment(fecha).format("DD/MM/YYYY") : "";

        return (
            <ParadigmaModal
                getUrl={(vars.get ? getUrlMisPedidosTipoPedido(tipo_pedido) : null)}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={missingPedidoIdMessage}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                className={'modal-lg'}
            >
                <Row>
                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Codigo Verificación"}
                            value={codigoVerificacion}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Orden"}
                            value={orden}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Fecha"}
                            value={fechaFormateada}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Estado"}
                            value={estado}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Planta"}
                            value={planta}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Lugar de Entrega"}
                            value={lugarDeEntrega}
                        />
                    </Col>

                    <Col className={'col-12'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Centro de Costo"}
                            value={centroDeCosto}
                        />
                    </Col>

                    <Col className={'col-12'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Persona"}
                            value={persona}
                        />
                    </Col>

                </Row>

                {/* Productos pedidos */}
                <Row>
                    <Col className={'col-12'}>
                        <Table striped hover size="sm" className="mt-3">
                            <thead>
                                <tr>
                                    <th width={'5%'}>N°</th>
                                    <th>Nombre</th>
                                    <th>Cantidad</th>
                                </tr>
                            </thead>

                            <tbody>
                                {(detalle.length == 0) ?
                                    <tr>
                                        <td className="text-center" colSpan={3}>No hay productos en el pedido.</td>
                                    </tr>
                                    :
                                    detalle.map(
                                        (d, i) =>
                                            <tr key={i} >
                                                <td width={'5%'}>{i + 1}</td>
                                                <td>{d.producto ? d.producto.descripcion : ''}</td>
                                                <td>{d.cantidad}</td>
                                            </tr>
                                    )}
                            </tbody>
                        </Table>
                    </Col>

                    <Col className={'col-12'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            type={'textarea'}
                            maxLength={1000}
                            label={"Observación"}
                            value={observacion}
                        />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/PedidosProducto/Modal.js